import { render } from "./partners.vue?vue&type=template&id=048f1742&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=048f1742&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048f1742"]])

export default __exports__